import { render, staticRenderFns } from "./CategoriaVariacao.vue?vue&type=template&id=6b5813e4&scoped=true&lang=pug"
import script from "./CategoriaVariacao.vue?vue&type=script&lang=js"
export * from "./CategoriaVariacao.vue?vue&type=script&lang=js"
import style0 from "./CategoriaVariacao.vue?vue&type=style&index=0&id=6b5813e4&prod&lang=scss"
import style1 from "./CategoriaVariacao.vue?vue&type=style&index=1&id=6b5813e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5813e4",
  null
  
)

export default component.exports